var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"effects fade-in"},[_c('Button',{attrs:{"alt":"Add Effect","size":"sm","centered":"","btnClass":"add-effect-btn"},on:{"handleButtonClick":_vm.addEffect}},[_vm._v(" + Add Effect ")]),_vm._l((_vm.effects),function(effect,index){return _c('EffectFields',{key:`effect-${index}`,attrs:{"effect":effect}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }